/* =============================================================================
   modo-ligero.js — El sitio se adapta solo a los equipos que no pueden con él
   Hotel La Gruta · Arequipa · 2026-10-21

   La luz (luz.js) y la vegetación (vines.js) son lo que hace al sitio, y lo
   que lo vuelve pesado en un teléfono de gama baja: medido con el procesador
   6× más lento, Inicio bajaba a 17 fps al hacer scroll y Habitaciones a 12.
   En «modo ligero» las dos quedan como con prefers-reduced-motion —la luz
   quieta en su hora, la vegetación ya crecida y con menos trazos— y la misma
   medición sube a 45–50 fps. Las escenas de scroll (GSAP) no cambian.

   Cómo se decide, en orden:
     · ?ligero=1 lo fuerza y ?ligero=0 lo impide (revisión y tests);
     · la visita ya lo activó (sessionStorage): las demás páginas arrancan
       ligeras sin volver a medir;
     · el navegador pide ahorrar datos o declara ≤ 2 GB de memoria;
     · si no, una sonda mide los cuadros por segundo DURANTE EL SCROLL (en
       reposo hasta un equipo 4× más lento va fluido; el problema aparece al
       desplazarse): dos ventanas de un segundo por debajo de UMBRAL fps
       activan el modo en caliente. luz.js y vines.js escuchan 'modo-ligero'.
       Tras 12 s de scroll medido sin fallar, el equipo aprobó y la sonda se
       retira. Con prefers-reduced-motion no hace falta nada de esto.

   Va ANTES que los demás scripts (defer conserva el orden): así luz.js y
   vines.js leen window.MODO_LIGERO al arrancar. En Playwright la sonda queda
   apagada (navigator.webdriver) salvo con ?sonda=1: la suite corre con carga
   y activaría el modo a mitad de un test que mide la luz o la vegetación.
   ============================================================================= */
(function () {
  'use strict';
  var html = document.documentElement;
  var CLAVE = 'lg-ligero';
  var q = new URLSearchParams(location.search), forzado = q.get('ligero');
  function leer() { try { return sessionStorage.getItem(CLAVE); } catch (e) { return null; } }
  function guardar(v) { try { sessionStorage.setItem(CLAVE, v); } catch (e) { /* sin sessionStorage: cada página mide */ } }

  var red = navigator.connection || {};
  var senales = red.saveData === true || (navigator.deviceMemory > 0 && navigator.deviceMemory <= 2);
  var motivo = forzado === '1' ? 'forzado' : leer() === '1' ? 'visita' : senales ? 'equipo' : '';
  var ligero = forzado !== '0' && !!motivo;

  window.MODO_LIGERO = ligero;
  if (ligero) { html.classList.add('ligero'); html.setAttribute('data-ligero', motivo); }

  function activar(porQue) {
    if (window.MODO_LIGERO) return;
    window.MODO_LIGERO = true;
    html.classList.add('ligero'); html.setAttribute('data-ligero', porQue);
    guardar('1');
    document.dispatchEvent(new CustomEvent('modo-ligero', { detail: { motivo: porQue } }));
  }
  window.ModoLigero = { activo: function () { return window.MODO_LIGERO; }, activar: activar };

  if (ligero || forzado === '0' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (navigator.webdriver && !q.has('sonda')) return;

  /* ── Sonda ──────────────────────────────────────────────────────────────
     Sólo corre mientras hay scroll (300 ms después del último evento se
     apaga) y arranca 2 s después de la carga: antes están la revelación del
     preloader y la entrada de la vegetación, que no son el régimen normal.
     Umbral 28 fps: con el procesador 4× más lento Inicio da 32 y
     Habitaciones 25 (ésta entra, aquélla no); 6× más lento, ambas entran. */
  var UMBRAL = 28, VENTANA = 1000, GOLPES = 2, SUFICIENTE = 12000, HUECO = 250;
  var activoHasta = 0, midiendo = false, ultimo = 0, cuadros = 0, tiempo = 0, golpes = 0, medido = 0, aprobado = false;

  function medir(ahora) {
    if (ahora > activoHasta || document.hidden || window.MODO_LIGERO || aprobado) { midiendo = false; ultimo = 0; return; }
    requestAnimationFrame(medir);
    if (ultimo) {
      var dt = ahora - ultimo;
      // Un hueco mayor no es un cuadro lento: es otra pestaña, un diálogo, un bloqueo ajeno.
      if (dt < HUECO) { cuadros++; tiempo += dt; }
    }
    ultimo = ahora;
    if (tiempo < VENTANA) return;
    var fps = cuadros * 1000 / tiempo;
    medido += tiempo; cuadros = 0; tiempo = 0;
    if (fps < UMBRAL) {
      if (++golpes >= GOLPES) activar('sonda:' + Math.round(fps) + 'fps');
    } else {
      golpes = Math.max(0, golpes - 1);
      if (medido >= SUFICIENTE) aprobado = true;
    }
  }
  function alScroll() {
    if (aprobado || window.MODO_LIGERO) { removeEventListener('scroll', alScroll); return; }
    activoHasta = performance.now() + 300;
    if (!midiendo) { midiendo = true; ultimo = 0; requestAnimationFrame(medir); }
  }
  document.addEventListener('visibilitychange', function () { if (document.hidden) { cuadros = 0; tiempo = 0; } });
  function armar() { setTimeout(function () { addEventListener('scroll', alScroll, { passive: true }); }, 2000); }
  if (document.readyState === 'complete') armar(); else addEventListener('load', armar);
})();
